import { visitStatusLabels } from '../../../Business/constants';

const visitsFormatters = {
  formatVisitStatus: visitStatus => <div>{visitStatusLabels[visitStatus]}</div>,
};

export default visitsFormatters;
